/* Halloween 2026 — Rewards section (copy + unlock via HH2026:game-played) */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
      return;
    }
    var ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    document.body.removeChild(ta);
  }

  function ensureHH2026() {
    if (!window.HH2026) {
      window.HH2026 = { played: {}, bestCoupon: null, bonusShown: false, couponsByGame: {} };
    }
    if (!window.HH2026.played) window.HH2026.played = {};
    if (!window.HH2026.couponsByGame) window.HH2026.couponsByGame = {};
    return window.HH2026;
  }

  function normalizeEntry(item) {
    if (!item) return null;
    if (typeof item === 'string') {
      return {
        code: item,
        shopUrl: '',
        shopScroll: 'none',
        shopLabel: '',
        couponScope: 'none'
      };
    }
    if (!item.code) return null;
    return {
      code: item.code,
      shopUrl: item.shopUrl || '',
      shopScroll: item.shopScroll || 'none',
      shopLabel: item.shopLabel || '',
      couponScope: item.couponScope || 'none'
    };
  }

  ready(function () {
    var root = document.getElementById('rewards');
    if (!root) return;

    var unlockedLabel = root.getAttribute('data-unlocked-label') || 'Unlocked';
    var lockedLabel = root.getAttribute('data-locked-label') || 'Locked';
    var notPlayedLabel = root.getAttribute('data-not-played-label') || 'Not played yet';
    var enterLabel = root.getAttribute('data-enter-label') || 'Enter →';
    var playAgainLabel = root.getAttribute('data-play-again-label') || 'Play again';
    var defaultShopLabel = root.getAttribute('data-shop-label') || 'Shop Eligible Products';
    var shopAllLabel = root.getAttribute('data-shop-all-label') || 'Shop All Products';
    var shopEligibleLabel =
      root.getAttribute('data-shop-eligible-label') || 'Shop Eligible Products';

    function labelForScope(scope, fallback) {
      // Only the first always-unlocked sitewide row uses Shop All Products by default.
      // Lottery / game codes default to Shop Eligible Products unless a custom label is set.
      if (scope === 'selected' || scope === 'sitewide' || scope === 'shipping' || scope === 'threshold') {
        return shopEligibleLabel;
      }
      return fallback || defaultShopLabel;
    }
    var countEl = root.querySelector('[data-rewards-count]');
    var hh = ensureHH2026();

    function isUnlocked(row) {
      if (row.getAttribute('data-always-unlocked') === 'true') return true;
      var status = row.getAttribute('data-status') || 'locked';
      if (status === 'unlocked') return true;
      if (status === 'locked') return false;
      if (status === 'game_locked') {
        var gameId = row.getAttribute('data-game-id');
        if (!(gameId && hh.played[gameId])) return false;
        // Lottery: stay locked until a real treat code exists (trick = no change).
        if (accumulatesCodes(gameId)) {
          var fromHh = hh.couponsByGame[gameId] || [];
          return fromHh.some(function (item) {
            var n = normalizeEntry(item);
            return n && n.code && !isLotteryPublicCode(n.code);
          });
        }
        return true;
      }
      return false;
    }

    function accumulatesCodes(gameId) {
      return gameId === 'lottery';
    }

    // Public sitewide code — not a Trick-or-Treat prize (comes from "trick" doors).
    function isLotteryPublicCode(code) {
      return String(code || '').toUpperCase() === 'GHOST15';
    }

    function getEntries(row) {
      var gameId = row.getAttribute('data-game-id') || '';
      var fromHh = gameId && hh.couponsByGame[gameId];
      if (fromHh && fromHh.length) {
        return fromHh
          .map(normalizeEntry)
          .filter(Boolean)
          .filter(function (entry) {
            return !(accumulatesCodes(gameId) && isLotteryPublicCode(entry.code));
          });
      }

      var raw = row.getAttribute('data-codes');
      if (raw) {
        try {
          var arr = JSON.parse(raw);
          if (Array.isArray(arr) && arr.length) {
            return arr
              .map(normalizeEntry)
              .filter(Boolean)
              .filter(function (entry) {
                return !(accumulatesCodes(gameId) && isLotteryPublicCode(entry.code));
              });
          }
        } catch (e) {}
      }

      // Lottery only shows real opened codes — never a placeholder like SURPRISE.
      if (accumulatesCodes(gameId)) return [];

      var single = row.getAttribute('data-code') || '';
      if (!single) return [];
      return [
        {
          code: single,
          shopUrl: row.getAttribute('data-shop-url') || '',
          shopScroll: row.getAttribute('data-shop-scroll') || 'none',
          shopLabel: row.getAttribute('data-shop-label') || defaultShopLabel
        }
      ];
    }

    function setEntries(row, entries) {
      var list = (entries || []).map(normalizeEntry).filter(Boolean);
      row.setAttribute('data-codes', JSON.stringify(list));
      row.setAttribute('data-code', list.length ? list[list.length - 1].code : '');
      var gameId = row.getAttribute('data-game-id');
      if (gameId) hh.couponsByGame[gameId] = list.slice();
    }

    function buildUnlockedBadge(row) {
      var html = '<div class="badge-unlocked">';
      var dot = row.getAttribute('data-unlocked-dot');
      if (dot) {
        html +=
          '<img src="' +
          dot +
          '" alt="" width="6" height="6" style="width:6px;height:6px">';
      }
      html += '<span>' + unlockedLabel + '</span></div>';
      return html;
    }

    function buildLockedBadge(row) {
      var html = '<div class="badge-locked">';
      var icon = row.getAttribute('data-locked-icon');
      if (icon) {
        html +=
          '<img src="' +
          icon +
          '" alt="" width="12" height="12" style="width:12px;height:12px">';
      }
      html += '<span>' + lockedLabel + '</span></div>';
      return html;
    }

    function escAttr(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;');
    }

    function buildOneBadge(code, copyIcon) {
      var html =
        '<div class="code-badge" data-code="' +
        escAttr(code) +
        '" role="button" tabindex="0">' +
        '<span class="code-badge-text">' +
        escAttr(code) +
        '</span>';
      if (copyIcon) {
        html +=
          '<img src="' +
          escAttr(copyIcon) +
          '" alt="" class="code-badge-icon" width="14" height="14">';
      }
      html += '</div>';
      return html;
    }

    function resolveShopLabel(entry, row) {
      var fallbackLabel = row.getAttribute('data-shop-label') || defaultShopLabel;
      if (entry && entry.shopLabel) return entry.shopLabel;
      return labelForScope(entry && entry.couponScope, fallbackLabel);
    }

    function isMobileRewards() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function buildOfferPairs(row, entries) {
      var copyIcon = row.getAttribute('data-copy-icon') || '';
      var fallbackUrl = row.getAttribute('data-shop-url') || '';
      var fallbackScroll = row.getAttribute('data-shop-scroll') || 'none';
      var html = '<div class="reward-offer-pairs">';
      entries.forEach(function (entry) {
        html += '<div class="reward-offer-pair">';
        html += buildOneBadge(entry.code, copyIcon);
        html += buildOneShopLink(row, {
          shopLabel: resolveShopLabel(entry, row),
          shopUrl: entry.shopUrl || fallbackUrl,
          shopScroll: entry.shopScroll || fallbackScroll
        });
        html += '</div>';
      });
      html += '</div>';
      return html;
    }

    function buildCodeStack(row, entries) {
      var copyIcon = row.getAttribute('data-copy-icon') || '';
      if (entries.length === 1) {
        return buildOneBadge(entries[0].code, copyIcon);
      }
      var html = '<div class="code-badge-stack">';
      entries.forEach(function (entry) {
        html += buildOneBadge(entry.code, copyIcon);
      });
      html += '</div>';
      return html;
    }

    function buildShopStack(row, entries) {
      var fallbackUrl = row.getAttribute('data-shop-url') || '';
      var fallbackScroll = row.getAttribute('data-shop-scroll') || 'none';
      if (entries.length === 1) {
        return buildOneShopLink(row, {
          shopLabel: resolveShopLabel(entries[0], row),
          shopUrl: entries[0].shopUrl || fallbackUrl,
          shopScroll: entries[0].shopScroll || fallbackScroll
        });
      }
      var html = '<div class="reward-shop-stack">';
      entries.forEach(function (entry) {
        html += buildOneShopLink(row, {
          shopLabel: resolveShopLabel(entry, row),
          shopUrl: entry.shopUrl || fallbackUrl,
          shopScroll: entry.shopScroll || fallbackScroll
        });
      });
      html += '</div>';
      return html;
    }

    function buildCodeBox(row, unlocked) {
      if (!unlocked) {
        return '<span class="reward-not-played">' + notPlayedLabel + '</span>';
      }
      var entries = getEntries(row);
      if (!entries.length) {
        return '<span class="reward-not-played">' + notPlayedLabel + '</span>';
      }
      var gameId = row.getAttribute('data-game-id') || '';
      if (accumulatesCodes(gameId) && entries.length > 0) {
        // Mobile: code+shop pairs. Desktop: code column only (shop stack separate).
        if (isMobileRewards()) return buildOfferPairs(row, entries);
        return buildCodeStack(row, entries);
      }
      return buildCodeStack(row, entries);
    }

    function buildOneShopLink(row, entry) {
      var label =
        (entry && entry.shopLabel) ||
        row.getAttribute('data-shop-label') ||
        defaultShopLabel;
      var scroll = (entry && entry.shopScroll) || 'none';
      var url = (entry && entry.shopUrl) || '';

      if (scroll && scroll !== 'none') {
        return (
          '<a class="reward-shop-link" href="#' +
          escAttr(scroll === 'mystery' ? 'mystery-box' : scroll) +
          '" data-scroll-' +
          escAttr(scroll) +
          '>' +
          escAttr(label) +
          '</a>'
        );
      }
      if (!url) return '<span class="reward-shop-empty" aria-hidden="true"></span>';
      return (
        '<a class="reward-shop-link" href="' +
        escAttr(url) +
        '" target="_blank" rel="noopener noreferrer">' +
        escAttr(label) +
        '</a>'
      );
    }

    function buildShopBox(row, unlocked) {
      var fallbackLabel = row.getAttribute('data-shop-label') || defaultShopLabel;
      var fallbackUrl = row.getAttribute('data-shop-url') || '';
      var fallbackScroll = row.getAttribute('data-shop-scroll') || 'none';

      if (!unlocked) {
        if (!fallbackUrl && (!fallbackScroll || fallbackScroll === 'none')) return '';
        return buildOneShopLink(row, {
          shopLabel: fallbackLabel,
          shopUrl: fallbackUrl,
          shopScroll: fallbackScroll
        });
      }

      var entries = getEntries(row);
      var gameId = row.getAttribute('data-game-id') || '';
      if (accumulatesCodes(gameId) && entries.length > 0) {
        // Pairs already include shop links on mobile.
        if (isMobileRewards()) return '';
        return buildShopStack(row, entries);
      }

      if (!entries.length) {
        if (!fallbackUrl && (!fallbackScroll || fallbackScroll === 'none')) return '';
        return buildOneShopLink(row, {
          shopLabel: fallbackLabel,
          shopUrl: fallbackUrl,
          shopScroll: fallbackScroll
        });
      }

      return buildShopStack(row, entries);
    }

    function wireCopy(badge) {
      if (!badge || badge._hhWired) return;
      badge._hhWired = true;
      function doCopy() {
        var code = badge.getAttribute('data-code') || '';
        if (!code) return;
        copyText(code);
        var textEl = badge.querySelector('.code-badge-text');
        if (textEl) {
          var orig = textEl.textContent;
          textEl.textContent = 'COPIED ✓';
          setTimeout(function () {
            textEl.textContent = orig;
          }, 1800);
        }
      }
      badge.addEventListener('click', doCopy);
      badge.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          doCopy();
        }
      });
    }

    function wireShopScroll(link) {
      if (!link || link._hhScrollWired) return;
      var scrollKey = '';
      ['giveaway', 'sale', 'mystery'].forEach(function (key) {
        if (link.hasAttribute('data-scroll-' + key)) scrollKey = key;
      });
      if (!scrollKey) return;
      link._hhScrollWired = true;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var id = scrollKey === 'mystery' ? 'mystery-box' : scrollKey;
        var el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function updateCount() {
      if (!countEl) return;
      var rows = root.querySelectorAll('.reward-row');
      var n = 0;
      rows.forEach(function (row) {
        if (isUnlocked(row)) n++;
      });
      countEl.textContent = '(' + n + ')';
    }

    function openLinkedGame(gameId) {
      if (!gameId) return;
      if (hh.openGame) {
        hh.openGame(gameId);
        return;
      }
      window.dispatchEvent(
        new CustomEvent('HH2026:open-game', { detail: { gameId: gameId } })
      );
      var gamesAnchor = document.getElementById('games-anchor');
      if (gamesAnchor) gamesAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function wireEnter(btn) {
      if (!btn || btn._hhWired) return;
      btn._hhWired = true;
      btn.addEventListener('click', function () {
        openLinkedGame(btn.getAttribute('data-game'));
      });
    }

    function renderRow(row) {
      var unlocked = isUnlocked(row);
      row.setAttribute('data-is-unlocked', unlocked ? 'true' : 'false');

      var codeBox = row.querySelector('.reward-code-box');
      var shopBox = row.querySelector('.reward-shop-box');
      var statusBox = row.querySelector('.reward-status-box');
      if (codeBox) codeBox.innerHTML = buildCodeBox(row, unlocked);
      if (shopBox) shopBox.innerHTML = buildShopBox(row, unlocked);
      if (statusBox) {
        statusBox.innerHTML = unlocked ? buildUnlockedBadge(row) : buildLockedBadge(row);
      }

      var enterBtn = row.querySelector('[data-reward-enter]');
      if (enterBtn) {
        var gameId = enterBtn.getAttribute('data-game');
        enterBtn.textContent = gameId && hh.played[gameId] ? playAgainLabel : enterLabel;
        wireEnter(enterBtn);
      }

      if (codeBox) {
        codeBox.querySelectorAll('.code-badge').forEach(wireCopy);
        codeBox.querySelectorAll('.reward-shop-link').forEach(wireShopScroll);
      }
      if (shopBox) {
        shopBox.querySelectorAll('.reward-shop-link').forEach(wireShopScroll);
      }
    }

    function renderAll() {
      root.querySelectorAll('.reward-row').forEach(renderRow);
      updateCount();
    }

    var mobileMq = window.matchMedia('(max-width: 768px)');
    var lastMobile = mobileMq.matches;
    function onViewportChange() {
      if (mobileMq.matches === lastMobile) return;
      lastMobile = mobileMq.matches;
      renderAll();
    }
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', onViewportChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(onViewportChange);
    }

    function unlockByGame(gameId, coupon, shop) {
      if (!gameId) return;
      hh.played[gameId] = true;
      if (!hh.couponsByGame[gameId]) hh.couponsByGame[gameId] = [];

      if (coupon && !(accumulatesCodes(gameId) && isLotteryPublicCode(coupon))) {
        var entry = normalizeEntry({
          code: coupon,
          shopUrl: (shop && shop.shopUrl) || '',
          shopScroll: (shop && shop.shopScroll) || 'none',
          shopLabel: (shop && shop.shopLabel) || '',
          couponScope: (shop && shop.couponScope) || 'none'
        });
        if (accumulatesCodes(gameId)) {
          var exists = hh.couponsByGame[gameId].some(function (item) {
            var n = normalizeEntry(item);
            return n && n.code === entry.code;
          });
          if (!exists) hh.couponsByGame[gameId].push(entry);
        } else {
          hh.couponsByGame[gameId] = [entry];
        }
      }

      if (accumulatesCodes(gameId) && hh.couponsByGame[gameId].length) {
        hh.couponsByGame[gameId] = hh.couponsByGame[gameId]
          .map(normalizeEntry)
          .filter(Boolean)
          .filter(function (entry) {
            return !isLotteryPublicCode(entry.code);
          });
      }

      root.querySelectorAll('.reward-row[data-game-id="' + gameId + '"]').forEach(function (row) {
        if (hh.couponsByGame[gameId].length) {
          setEntries(row, hh.couponsByGame[gameId]);
        }
        if (row.getAttribute('data-status') === 'game_locked') {
          renderRow(row);
        }
      });
      updateCount();
    }

    Object.keys(hh.played).forEach(function (id) {
      if (hh.played[id]) unlockByGame(id);
    });
    renderAll();

    window.addEventListener('HH2026:game-played', function (e) {
      var detail = (e && e.detail) || {};
      var gameId = detail.gameId;
      if (gameId) {
        unlockByGame(gameId, detail.coupon, {
          shopUrl: detail.shopUrl || '',
          shopScroll: detail.shopScroll || 'none',
          shopLabel: detail.shopLabel || '',
          couponScope: detail.couponScope || 'none'
        });
      }
    });
  });
})();
